import { cn } from '@/lib/utils'
import { normalizeRichTextHtml, plainTextToRichTextHtml } from '@/lib/rich-text'

export type RichTextContentProps = {
  html?: string | null
  fallbackText?: string | null
  className?: string
  /** Keeps the runs of spaces florists type to line recipes up as grids. */
  preserveSpaces?: boolean
}

export function RichTextContent({
  html = null,
  fallbackText = null,
  className = '',
  preserveSpaces = false,
}: RichTextContentProps) {
  const contentHtml =
    normalizeRichTextHtml(html, { preserveSpaces }) ||
    plainTextToRichTextHtml(fallbackText, { preserveSpaces })

  if (!contentHtml) {
    return null
  }

  return (
    <div
      className={cn(
        'text-sm leading-6 text-foreground',
        '[&_p+_p]:mt-3',
        '[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_li+_li]:mt-1',
        '[&_a]:text-interaction [&_a]:underline [&_a]:underline-offset-2',
        '[&_strong]:font-semibold [&_em]:italic [&_u]:underline [&_u]:underline-offset-2',
        className
      )}
      dangerouslySetInnerHTML={{ __html: contentHtml }}
    />
  )
}
